import script from "./ReceitasRecebidasRecebimento.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceitasRecebidasRecebimento.vue?vue&type=script&setup=true&lang=js"

import "./ReceitasRecebidasRecebimento.vue?vue&type=style&index=0&id=f2d31526&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2d31526"]])

export default __exports__